import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';
import pKullaniciKontrol from '../../../../api/models/pKullaniciKontrol';

export default ApiBaseReducer<
  pKullaniciKontrol,
  IInputDataStateModel<pKullaniciKontrol, boolean>,
  boolean
>(ActionSubTypes.API_KULLANICIKONTROL, DefaultInputDataStateModel<pKullaniciKontrol, boolean>());
